export interface PloneRestApiResultValueToken {
  title: string;
  token: string;
}

export const extractToken = (
  raw: PloneRestApiResultValueToken | PloneRestApiResultValueToken[]
) => {
  if (raw === null || raw === undefined) {
    return null;
  }
  if (Array.isArray(raw)) {
    return raw.map(elem => extractToken(elem)) as string[];
  }
  if (typeof raw !== "object") {
    return raw;
  }
  return raw.hasOwnProperty("token") ? raw.token : null;
};



// WEBPACK FOOTER //
// ./src/app/utils/get-plone-token.ts